import { makeGqlSuspenseQuery } from '@/utilities/gqlQuery';
import { gql, ResultOf } from '@/utilities/gql';

const QUERY = gql(`
  query getPortfolioHoldingsDividendForecast($portfolioId: String!) {
    portfolioHoldingsDividendForecast(id: $portfolioId) {
      isAnalysisRestricted
      company {
        id
        name
        canonicalURL
        exchangeCountryISO
        tickerSymbol
        exchangeSymbol
        uniqueSymbol
        score {
          value
          future
          past
          health
          dividend
          sentence
          total
        }
      }
      dividendForecast {
        last1y {
          payment,
          dividendYield,
          yieldOnCapitalInvested
          dividendPaymentsGrowthAnnual,
        }
        next1y {
          payment,
          dividendYield,
          yieldOnCapitalInvested
          dividendPaymentsGrowthAnnual,
        }
        next2y {
          payment,
          dividendYield,
          yieldOnCapitalInvested
          dividendPaymentsGrowthAnnual,
        }
        next3y {
          payment,
          dividendYield,
          yieldOnCapitalInvested
          dividendPaymentsGrowthAnnual,
        }
      }
    }
  }
`);

export const usePortfolioHoldingsDividendForecast = makeGqlSuspenseQuery(
  QUERY,
  {
    staleTime: 1000 * 60 * 60,
  }
);

export type PortfolioDividendForecastData = ResultOf<typeof QUERY>;
